const state = {
	activeIndex: 0,
}

const mutations = {
	SET_ActiveIndex: (state, data) => {
		state.activeIndex = data
	},
}

const actions = {
	ChangeIndex({ commit },data) {
		return new Promise(resolve => {
			commit('SET_ActiveIndex', data)
			resolve(data)
		})
	},
}

export default {
	namespace: true,
	actions,
	state,
	mutations,
}



// WEBPACK FOOTER //
// ./src/store/modules/active.js